import { EXPIRY_DATE_TYPES } from "constants/expiryDateType";

function expiryDateTypeToLabel(code) {
  return EXPIRY_DATE_TYPES[code];
}

export { expiryDateTypeToLabel };
